<app-header></app-header>
<section class="section">
  <!-- Section Start -->
  <section class="my-4 bg-light d-table w-100">
    <h4 class="text-center title"> {{'Buyer.AllProducts' |translate}} </h4>
  </section>
  <!-- Start Products -->
  <div class="container">
    <div class="row justify-content-end mb-2">
      <div class="col-lg-9 col-md-8 col-12">
        <div class="d-flex justify-content-end align-items-center">
          <div class="section-title">
            <h5 class="">{{'EventPage.Showing' |translate}} {{products.length}}  {{'EventPage.products_of' |translate}}  {{totalItems}} {{'EventPage.results' |translate}}</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-md-4 col-12 pt-2">
        <div class="card shadow rounded border-0 sidebar sticky-bar">
          <div class="card-body">
            <!-- Type -->
            <div class="widget">
              <h6 class="widget-title">{{'Buyer.Type' |translate}}</h6>
              <select class="form-select form-control" aria-label="Default select example" id="product-type"
                      name="type" [(ngModel)]="selectedType" (change)="typeChanged($event.target)">
                <option selected value="0">{{'EventPage.All' |translate}}</option>
                <option *ngFor="let type of productTypes" [value]="type.id">{{type.name}}</option>
              </select>
            </div>
            <!-- Categories -->
            <div class="widget mt-3 pt-2">
              <h6 class="widget-title">{{'EventPage.Categories' |translate}}</h6>
              <select class="form-select form-control" aria-label="Default select example" id="product-category"
                      [(ngModel)]="category" name="category">
                <option value="" selected>{{'EventPage.All' |translate}}</option>
                <option *ngFor="let category of categories" [value]="category.id">
                  {{category.name}}
                </option>
              </select>
            </div>
            <!-- SEARCH -->
            <div class="widget mt-3 pt-2">
              <h6 class="widget-title">{{'Welcome.Search' |translate}}</h6>
              <form role="search" method="get" id="search">
                <div class="input-group mb-3 border rounded">
                  <input placeholder="{{'EventPage.Search_by_name' |translate}}" [(ngModel)]="name" type="text" name="name" class="form-control">
                  <button type="submit" class="input-group-text bg-primary text-white border-0" id="searchsubmit"
                          (click)="fetchProducts()">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- Products List -->
      <div class="col-lg-9 col-md-8 col-12">
        <div class="row">
          <!-- Products -->
          <div class="col-lg-4 col-sm-6 pt-2" *ngFor="let product of products">
            <div class="card shop-list border-0 position-relative">
              <ul class="label list-unstyled mb-0">
                <li><span class="badge badge-link rounded-pill bg-success">{{product.name}}</span></li>
              </ul>
              <div class="shop-image position-relative overflow-hidden rounded shadow">
                <a routerLink="/{{product.code}}"><img src="{{product.productImage}}" class="img-fluid product-img-size" alt="{{product.name}}"></a>
              </div>
              <div class="card-body content pt-4 p-2">
                <a routerLink="/{{product.code}}" class="text-dark product-name fs-6">{{product.productName}}</a>
                <!--<div class="d-flex justify-content-between mt-1">
                  <h6 class="text-muted small fst-italic mb-0 mt-1">$16.00 <del class="text-danger ms-2">$21.00</del> </h6>
                </div>-->
              </div>
            </div>
          </div>
          <!-- PAGINATION START -->
          <div *ngIf="totalItems > 0" class="row justify-content-center">
            <div class="col-auto pt-4">
              <pagination [boundaryLinks]="true"
                          [totalItems]="totalItems"
                          [maxSize]="5"
                          (pageChanged)="onPageChanged($event)"
                          [(ngModel)]="currentPage"
                          [itemsPerPage]="itemsPerPage"
                          previousText="&lsaquo;"
                          nextText="&rsaquo;"
                          firstText="&laquo;"
                          lastText="&raquo;">
              </pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</section>


<app-footer></app-footer>
